import * as API from '@/api'
import { auth, user } from '@/services/'
import { extractDataFromResponse } from '@/helpers/authExtraction'

const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_ERROR = 'LOGIN_ERROR'
const CLEAR_PREVIOUS_ERROR = 'CLEAR_PREVIOUS_ERROR'
const START_LOADING_BUTTON = 'START_LOADING_BUTTON'
const STOP_LOADING_BUTTON = 'STOP_LOADING_BUTTON'
const RESET_LOGIN_DATA = 'RESET_LOGIN_DATA'

const initialState = {
  loginSuccess: null,
  loginError: null,
  isLoginButtonLoading: false
}

const state = { ...initialState }

const mutations = {

  [LOGIN_SUCCESS]: function (state) {
    state.loginSuccess = true
  },

  [LOGIN_ERROR]: function (state, value) {
    state.loginError = value
  },

  [CLEAR_PREVIOUS_ERROR]: function (state) {
    state.loginError = null
  },

  [START_LOADING_BUTTON]: function (state) {
    state.isLoginButtonLoading = true
  },

  [STOP_LOADING_BUTTON]: function (state) {
    state.isLoginButtonLoading = false
  },

  [RESET_LOGIN_DATA]: function (state) {
    state.loginSuccess = false
    state.loginError = null
  }
}

const actions = {
  async login ({ commit }, { credentials, selectedBuilding }) {
    commit(START_LOADING_BUTTON)
    commit(CLEAR_PREVIOUS_ERROR)

    let apiResponse = null

    try {
      apiResponse = await API.login.auth.authenticate(credentials)
    } catch (error) {
      commit(LOGIN_ERROR, error.response?.data?.errors[0])
    }

    commit(STOP_LOADING_BUTTON)

    try {
      if (apiResponse) {
        await user.setSelectedBuilding(selectedBuilding)
        await auth.setUserAuthData(extractDataFromResponse(apiResponse))
        commit(LOGIN_SUCCESS)
      } else {
        commit(LOGIN_ERROR, 'Falha na autenticação, tente novamente mais tarde.')
      }
    } catch (error) {
      commit(LOGIN_ERROR, 'Falha na autenticação, tente novamente mais tarde.')
      auth.removeUserAuthData()
      user.removeSelectedBuilding()
    }
  },

  logout ({ commit }) {
    commit(RESET_LOGIN_DATA)
    auth.removeUserAuthData()
    user.removeSelectedClassroom()
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
